import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'disabled'>()((_theme, _params, classes) => ({
    root: {
        boxSizing: 'content-box'
    },
    disabled: {},
    outlined: {
        padding: '13px 20px',
        border: '1px solid #EEEEEE',
        borderRadius: 16,
        fontWeight: 400,
        fontSize: 13,
        lineHeight: '16px',
        color: '#282D31'
    },
    contained: {
        padding: '14px 20px',
        borderRadius: 16,
        fontWeight: 500,
        fontSize: 13,
        lineHeight: '16px',
        color: '#fff',
        boxShadow: 'none !important',
        background: '#6161E1',
        [`&.${classes.disabled}`]: {
            color: '#fff',
            background: '#6161E1',
            opacity: 0.7
        },
        '&:hover': {
            background: '#7373F5'
        },
        '&:focus': {
            background: '#6161E1'
        },
        '&:active': {
            background: '#5353DA'
        }
    }
}));
